import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useAuthContext} from "../services/auth.service";
import Logo from "../components/_core/logo";
import Button from "../components/_core/Button";
import Input from "../components/_core/Input";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExclamationCircle} from "@fortawesome/free-solid-svg-icons";


const HomePage = () => {
    const navigate = useNavigate();
    const {user, authLoaded, login} = useAuthContext();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        document.title = "GT2 - Log In";
    }, []);

    async function handleLogin(e) {
        e.preventDefault();
        setErrorMsg("");
        setIsLoading(true);

        try {
            await login(username, password);
        } catch (error) {
            setErrorMsg(error.message);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (user && navigate) {
            navigate("/datasets");
        }
    }, [user, navigate])

    const isFormValid = username && password && password.length >= 4;

    return (
        <div className="flex flex-col items-center gap-4 -mt-16">

            {!user ? <>
                <div>
                    <Logo className="w-64 mb-2 "/>
                    <h2 className="text-2xl text-slate-500">IKE Insight Ground Truth <strong
                        className="text-lg">V2</strong></h2>
                </div>
                <div className="px-12 pb-12 pt-8 bg-white rounded-lg shadow-sm">
                    <h2 className="text-3xl mb-6 font-semibold">Log In</h2>
                    {errorMsg && (
                        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded text-red-700 text-sm flex items-center gap-2">
                            <FontAwesomeIcon icon={faExclamationCircle} />
                            <span>{errorMsg}</span>
                        </div>
                    )}
                    <form onSubmit={handleLogin} className="flex flex-col w-80">

                        <Input name="username" className="mb-4 p-1"
                               label="Username"
                               required={true}
                               autoComplete="username"
                               onChange={(e) => setUsername(e.target.value)}/>
                        <Input type="password" name="password" className="mb-6 p-1" required={true}
                               label="Password"
                               autoComplete="current-password"
                               onChange={(e) => setPassword(e.target.value)}/>
                        <Button type="submit" disabled={!isFormValid || isLoading}
                                extraClasses="w-full">
                            {isLoading ? "Logging in..." : "Log In"}
                        </Button>
                    </form>
                </div>
                <p className="text-sm text-gray-400">&copy; {new Date().getFullYear()} ikeGPS Ltd. All Rights Reserved.</p>
            </> : <p className="text-lg text-gray-500">Loading...</p>}

        </div>
    )
}

export default HomePage;
